<template>
  <div class="home-page">
    <header class="header">
      <div class="header-inner">
        <div class="header-left">
          <div class="logo-icon"><i class="fas fa-broadcast-tower"></i></div>
          <h1>格力之声 <span>· 工作平台</span></h1>
          <div class="wave-bars"><span></span><span></span><span></span><span></span><span></span></div>
        </div>
      </div>
    </header>

    <div class="hero">
      <div class="hero-inner">
        <h2 class="hero-title">欢迎使用格力之声工作平台</h2>
        <p class="hero-subtitle">选择您需要的功能模块开始工作</p>
      </div>
    </div>

    <div class="cards-wrap">
      <div class="nav-cards">
        <div class="nav-card schedule-card" @click="goTo('/schedule')">
          <div class="card-icon"><i class="fas fa-calendar-days"></i></div>
          <div class="card-body">
            <h3>排班管理</h3>
            <p>安排每日广播人员排班表，管理早间、午间、晚间播报人员</p>
          </div>
          <div class="card-arrow"><i class="fas fa-arrow-right"></i></div>
        </div>

        <div class="nav-card write-card" @click="goTo('/write')">
          <div class="card-icon"><i class="fas fa-pen-to-square"></i></div>
          <div class="card-body">
            <h3>撰稿工具</h3>
            <p>广播稿件撰写工具，自动分段、字数统计、导出Word文档</p>
          </div>
          <div class="card-arrow"><i class="fas fa-arrow-right"></i></div>
        </div>

        <div class="nav-card music-card" @click="goTo('/music')">
          <div class="card-icon"><i class="fas fa-music"></i></div>
          <div class="card-body">
            <h3>音乐控制</h3>
            <p>开始音乐固定播放、结束音乐从乐曲库随机抽取，完全离线</p>
          </div>
          <div class="card-arrow"><i class="fas fa-arrow-right"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  methods: {
    goTo(path) {
      this.$router.push(path);
    }
  }
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  background: var(--bg, #f5f0e8);
  position: relative;
}
.home-page::before {
  content: ''; position: fixed; inset: 0; z-index: -1;
  background:
    radial-gradient(ellipse at 20% 50%, rgba(180,83,9,0.04), transparent 60%),
    radial-gradient(ellipse at 80% 20%, rgba(3,105,161,0.03), transparent 50%),
    linear-gradient(180deg, #f5f0e8 0%, #ede7db 100%);
}
/* Header */
.header {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  color: #fff; position: sticky; top: 0; z-index: 100;
  box-shadow: 0 2px 20px rgba(0,0,0,0.15);
}
.header-inner {
  max-width: 1200px; margin: 0 auto; padding: 16px 24px;
  display: flex; align-items: center;
}
.header-left { display: flex; align-items: center; gap: 16px; }
.logo-icon {
  width: 44px; height: 44px; border-radius: 50%;
  background: linear-gradient(135deg, #b45309, #d97706);
  display: flex; align-items: center; justify-content: center;
  font-size: 20px; color: #fff; flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(180,83,9,0.3);
}
.header h1 {
  font-family: 'SimHei', 'Microsoft YaHei', 'PingFang SC', sans-serif;
  font-size: 1.5rem; font-weight: 700; letter-spacing: 0.5px;
}
.header h1 span { color: #b45309; font-weight: 600; }
/* Hero */
.hero {
  max-width: 1200px; margin: 0 auto; padding: 60px 24px 40px;
  text-align: center;
}
.hero-title {
  font-size: 2rem; font-weight: 700; color: #1e293b;
  margin-bottom: 12px;
}
.hero-subtitle {
  font-size: 1.1rem; color: #64748b;
}
/* Cards */
.cards-wrap {
  max-width: 1200px; margin: 0 auto; padding: 0 24px 80px;
}
.nav-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
}
.nav-card {
  background: #fff; border-radius: 10px; padding: 40px 32px;
  cursor: pointer; transition: all 0.3s;
  border: 1px solid #e2d9cc; box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  display: flex; align-items: center; gap: 24px;
  position: relative; overflow: hidden;
}
.nav-card::before {
  content: ''; position: absolute; top: 0; left: 0; right: 0; height: 4px;
  background: linear-gradient(90deg, #b45309, #d97706);
  transform: scaleX(0); transform-origin: left; transition: transform 0.3s;
}
.nav-card:hover::before { transform: scaleX(1); }
.nav-card:hover {
  transform: translateY(-4px); box-shadow: 0 8px 30px rgba(0,0,0,0.12);
  border-color: #b45309;
}
.card-icon {
  width: 64px; height: 64px; border-radius: 16px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  font-size: 28px; color: #fff;
}
.schedule-card .card-icon { background: linear-gradient(135deg, #0369a1, #0284c7); }
.write-card .card-icon { background: linear-gradient(135deg, #b45309, #d97706); }
.music-card .card-icon { background: linear-gradient(135deg, #6d28d9, #8b5cf6); }
.card-body { flex: 1; }
.card-body h3 {
  font-size: 1.3rem; font-weight: 700; color: #1e293b; margin-bottom: 8px;
}
.card-body p {
  font-size: 0.9rem; color: #64748b; line-height: 1.6;
}
.card-arrow {
  font-size: 1.2rem; color: #94a3b8; transition: all 0.3s;
}
.nav-card:hover .card-arrow {
  color: #b45309; transform: translateX(6px);
}
/* Wave animation */
.wave-bars { display: flex; align-items: end; gap: 2px; height: 20px; margin-left: 8px; }
.wave-bars span {
  display: block; width: 3px; background: #b45309; border-radius: 2px;
  animation: wave 1.2s ease-in-out infinite;
}
.wave-bars span:nth-child(1) { height: 8px; animation-delay: 0s; }
.wave-bars span:nth-child(2) { height: 16px; animation-delay: 0.15s; }
.wave-bars span:nth-child(3) { height: 10px; animation-delay: 0.3s; }
.wave-bars span:nth-child(4) { height: 18px; animation-delay: 0.45s; }
.wave-bars span:nth-child(5) { height: 6px; animation-delay: 0.6s; }
@keyframes wave {
  0%, 100% { transform: scaleY(0.5); opacity: 0.5; }
  50% { transform: scaleY(1); opacity: 1; }
}
/* Responsive */
@media (max-width: 768px) {
  .hero { padding: 40px 16px 24px; }
  .hero-title { font-size: 1.5rem; }
  .hero-subtitle { font-size: 0.95rem; }
  .nav-cards { grid-template-columns: 1fr; gap: 16px; }
  .nav-card { padding: 28px 20px; gap: 16px; }
  .card-icon { width: 52px; height: 52px; font-size: 22px; }
  .card-body h3 { font-size: 1.1rem; }
}
</style>
